import { Inlines } from '../Inlines';

export default function ListBlock({ block }) {
  const Tag = block.style === 'ordered' ? 'ol' : 'ul';
  return (
    <Tag className="content-list">
      {(block.items || []).map((item, i) => (
        <li key={i}>
          <Inlines nodes={item.children} />
          {item.list && <ListBlock block={item.list} />}
        </li>
      ))}
    </Tag>
  );
}
